import deprecatedEn from "./en/deprecated.json";
import whatsNewEn from "./en/whatsNew.json";
import deprecatedTr from "./tr/deprecated.json";
import whatsNewTr from "./tr/whatsNew.json";

export const RELEASE_NOTE_DICTIONARIES: Record<"tr" | "en", Record<string, string>> = {
    en: {
        ...deprecatedEn,
        ...whatsNewEn
    },
    tr: {
        ...deprecatedTr,
        ...whatsNewTr
    }
};
